import React, { useState } from 'react'

import dayjs from 'dayjs'
import { Avatar } from 'antd'
import Icon from '@forwardflow/ui/Icons'

interface MessageItemProps {
   item: any
}

export const CallAgentItem: React.FC<MessageItemProps> = ({ item }) => {
   const [isExpanded, setIsExpanded] = useState(false)

   const toggleExpand = () => {
      setIsExpanded(!isExpanded)
   }
   return (
      <div className="flex items-end justify-end gap-x-2">
         <div className="flex flex-col bg-[#E84749]/30  max-w-[450px] rounded-3xl rounded-br-none overflow-hidden">
            <div className="flex items-center justify-between py-4 pl-4 pr-6 gap-x-4">
               <div className="w-8 h-8 rounded-full bg-black/30 flexc shrink-0">
                  <Icon name="MissedCall" />
               </div>
               <div className="flex flex-col items-end justify-between gap-y-1">
                  <p className="text-[14px] font-medium">{item?.content}</p>
                  <p className="text-[10px] text-white/70">
                     {dayjs(item?.ts).format('h:mm A, D MMM YYYY')}
                  </p>
               </div>
            </div>

            <div
               className="flex items-center gap-x-6 px-5 py-3 text-[12px] bg-[#383A3E] justify-between cursor-pointer"
               onClick={toggleExpand}
            >
               <Icon name="Transcript" className="w-8 h-8 text-white/50" />
               <div
                  className={`${
                     isExpanded ? '' : 'line-clamp-1'
                  } transition-all duration-200`}
               >
                  {item?.data}
               </div>
               <Icon
                  name="arrow-down"
                  className={`${isExpanded ? '-rotate-180' : ''}`}
               />
            </div>
         </div>
         <Avatar src={item?.assistant?.avatar} className="w-10 h-10">
            {item?.assistant?.name.slice(0, 1) || 'A'}
         </Avatar>
      </div>
   )
}
